import {concat, constant, emptyArray} from '@packages/utilities/fp/utils';
import {isOptimizationBaseElement} from '@packages/utilities/platform';
import {Expressions, matchExpression} from '@packages/systems/wfdl';
import type {Expression} from '@packages/systems/wfdl-ast';

const dataPropsMatcher = matchExpression({
  Select: ({from, prop}) => {
    if (Expressions.isDataVariable(from)) {
      return Expressions.stop([prop]);
    }

    return Expressions.stop(emptyArray);
  },
  Element: constant(Expressions.stop(emptyArray)),
  _: constant(Expressions.resume(emptyArray)),
});

const outerElementMatcher = matchExpression({
  Element: (el) => {
    if (isOptimizationBaseElement(el)) {
      return Expressions.stop(emptyArray);
    }

    const dataProps = Expressions.everything(concat)(dataPropsMatcher)(
      Expressions.getElementData(el)
    );

    return Expressions.resume(dataProps);
  },
  _: constant(Expressions.resume(emptyArray)),
});

/**
 * Collect all the bound data property ids that exist in an expression, ignoring the contents inside base variations.
 */
export const getPropertiesNotExclusiveToBaseVariation = (
  expression: Expression
): string[] => Expressions.everything(concat)(outerElementMatcher)(expression);
